<template>
  <div>
    <br />
    <br />
    <v-card max-width="1000" class="mx-auto" elevation="0">
      <v-list>
        <v-list-item class="px-2">
          <v-list-item-avatar>
            <img
              src="img/icons8-avatar-64.png"
              @click="profile"
              v-if="user.avatar == null"
            />
            <v-img
              :src="getImage('/' + user.avatar)"
              @click="profile"
              v-if="user.avatar != null"
            ></v-img>
          </v-list-item-avatar>
        </v-list-item>

        <v-list-item link>
          <v-list-item-content>
            <v-list-item-title class="text-h6">
              {{ user.name }}
            </v-list-item-title>
            <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list nav dense>
        <v-list-item link>
          <v-list-item-icon>
            <v-icon>mdi-card-account-phone-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ user.phone }}</v-list-item-title>
        </v-list-item>

        <v-list-item link>
          <v-list-item-icon>
            <v-icon>mdi-list-status</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ user.status }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-card>

    <v-hover v-slot="{ hover }">
      <v-card class="mx-auto" color="grey lighten-4" max-width="1000">
        <v-img
          :aspect-ratio="16 / 9"
          src="https://cdn.vuetifyjs.com/images/cards/kitchen.png"
        >
          <!-- <v-expand-transition>
            <div
              v-if="hover"
              class="d-flex transition-fast-in-fast-out blue darken-2 v-card--reveal text-h2 white--text"
              style="height: 100%"
            ></div>
          </v-expand-transition> -->
        </v-img>
        <v-card-text class="pt-6" style="position: relative">
          <v-btn absolute color="#1B5E20" class="white--text" fab large right top>
            <v-icon>mdi-cart</v-icon>
          </v-btn>
          <h3 class="font-weight-light">
            Your IoT service will expire on:
            <v-list-item v-for="(iot, i) in iots" :key="i">
              <v-list-item-icon>
                <v-icon v-text="iot.icon" color="orange" x-large></v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title v-text="iot.expired_date"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </h3>
          <div class="font-weight-light">
            To create an extension, click the cart image.
          </div>
        </v-card-text>
      </v-card>
    </v-hover>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      user: "auth/user",
    }),
  },
  data: () => ({
    valid: true,
    name: "",
    nameRules: [
      (v) => !!v || "Name is required",
      (v) => (v && v.length <= 10) || "Name must be less than 10 characters",
    ],
    email: "",
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    select: null,
    items: ["Item 1", "Item 2", "Item 3", "Item 4"],
    checkbox: false,
    iots: [],
  }),
  mounted() {
    let config = {
      headers: {
        Authorization: "Bearer " + this.user.api_token,
      },
    };
    let url = "/api_key_iot";
    url = url + "?page=" + this.page;
    url = encodeURI(url);
    this.axios
      .get(url, config)
      .then((response) => {
        let { data } = response.data;
        this.iots = data;
      })
      .catch((error) => {
        let { responses } = error;
        console.log(responses);
      });
  },

  methods: {
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    uploadImage(event) {
      const URL = "https://master.indorobotika.com/public/storage/avatars";

      let data = new FormData();
      data.append("name", "my-picture");
      data.append("file", event.target.files[0]);

      let config = {
        header: {
          "Content-Type": "multipart/form-data",
        },
      };

      this.axios.put(URL, data, config).then((response) => {
        console.log("image upload response > ", response);
      });
    },
    profile() {
      this.$router.push("/profile");
    },
  },
};
</script>
<style>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.5;
  position: absolute;
  width: 100%;
}
</style>
